import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Container, Grid, Button } from "@mantine/core";
import { MantineReactTable } from "mantine-react-table";
import "./Approval.css";
import axios from "axios";
import {
  getUserId,
  leaverequestview,
  AddOfficiating,
  GetAllHead,
  GetDepartment,
  HEADERS,
  getDepId,
  getOrgId,
  setUserId,
} from "../api";
import Swal from "sweetalert2";

function Approval() {
  const [OfficiatingData, setOfficiatingData] = useState([]);
  const [dataview, setdataview] = useState([]);
  const [usergetall, setusergetall] = useState([]);
  const [departments, setDepartment] = useState([]);
  const SelectElement = document.createElement("select");
  const [page, setPage] = useState(0); // Track the current page
  const [pageSize, setPageSize] = useState(5); // Track the page size

  if (usergetall?.length > 0) {
    // Check if usergetall has values before iterating
    usergetall.forEach((optionText) => {
      const option = document.createElement("option");
      option.text = option.value = optionText;
      SelectElement.add(option);
    });
  } else {
    // console.error("Head get all is undefined");
  }

  const Element = document.createElement("select");
  Element.id = "department";
  departments?.forEach((optionText) => {
    // Check if departments has values before iterating
    const option = document.createElement("option");
    option.text = option.value = optionText;
    Element.add(option);
  });

  const addLeavePolicy = () => {
    Swal.fire({
      title: "Add Officiating Person",
      showCancelButton: true,
      confirmButtonText: "Appoint",
      cancelButtonText: "Cancel",
      reverseButtons: true,
      customClass: {
        confirmButton: "swal-custom-confirm-btn",
        cancelButton: "swal-custom-cancel-btn",
      },
      html: `
      <div class="p-2 d-flex flex-column gap-2">
        <div class="d-flex flex-column">
          <small class="text-start">Head</small>
<select id="officiated_person" class="form-select mt-1" placeholder="Officiated Person" autofocus>
  <option value="" disabled selected>Select Head</option>
  ${
    usergetall?.length > 0 &&
    usergetall
      .filter((users) => users.user_id !== localStorage.getItem("user_id")) // Exclude current user
      .map(
        (users) =>
          `<option value="${users.user_id}">${users.first_name} ${users.last_name}</option>`
      )
      .join("")
  }
</select>

        </div>
        <div class="d-flex flex-column">
          <small class="text-start">Department</small>
          <select id="department" class="form-select mt-1" placeholder="Department" autofocus>
            <option value="" disabled selected>Select Department</option>
            ${
              departments?.length > 0 &&
              departments
                .map(
                  (department) =>
                    `<option value="${department.dept_id}">${department.dept_name}</option>`
                )
                .join("")
            }
          </select>
        </div>

        <div class="d-flex flex-column">
          <small class="text-start">Start Date</small>
          <input 
            id="appoint_from_date" 
            type="date" 
            class="form-control mt-1" 
            placeholder="From Date" 
            onfocus="(this.type ='date')" 
            onblur="(this.type='text')" 
            autofocus
          >    
        </div>
        <div class="d-flex flex-column">
          <small class="text-start">End Date</small>
          <input 
            id="appoint_to_date" 
            type="date" 
            class="form-control mt-1" 
            placeholder="To Date" 
            onfocus="(this.type ='date')" 
            onblur="(this.type='text')" 
            autofocus
          >  
        </div>
      </div>
    `,

      preConfirm: async () => {
        const officiated_user =
          Swal.getPopup().querySelector("#officiated_person").value;
        const officiated_department =
          Swal.getPopup().querySelector("#department").value;
        const from_date =
          Swal.getPopup().querySelector("#appoint_from_date").value;
        const to_date = Swal.getPopup().querySelector("#appoint_to_date").value;

        if (
          !officiated_user ||
          !officiated_department ||
          !from_date ||
          !to_date
        ) {
          Swal.showValidationMessage("Please fill in all the fields");
          console.error("Please fill in all the fields");

          return { success: false, message: "Please fill in all the fields" };
        }

        const UserId = getUserId();
        const requestBody = {
          officiated_person: officiated_user,
          department_id: officiated_department,
          begin_date: from_date,
          end_date: to_date,
          officiated_by: UserId,
        };

        // console.log("officiating person:::::::::::::::::::", requestBody)

        try {
          const response = await fetch(AddOfficiating, {
            method: "POST",
            headers: HEADERS,
            body: JSON.stringify(requestBody),
          });

          // $&

          if (response.ok) {
            const result = await response.json();

            if (result.response_code === "0000") {
              setOfficiatingData([...OfficiatingData, result]);
              //navigate('/approval')

              Swal.fire(
                "Success!",
                `${response.response_description}`,
                "success"
              );

              // $&
              return {
                success: true,
                message: result.response_description,
              };
            } else {
              Swal.fire({
                title: response.data.response_description || "Error",
                text:
                  response.data.response_description || "Something went wrong.",
                icon: "error",
                confirmButtonText: "OK",
              });
              return { success: false, message: result.response_description };
            }
          } else {
            // Handle non-OK response (e.g., network error)
            console.error("Failed to communicate with the server");
            return {
              success: false,
              message: "Failed to communicate with the server",
            };
          }
        } catch (error) {
          console.error("Error during Adding Officiating Person:", error);
          return {
            success: false,
            message: "Error during Adding Officiating Person",
          };
        }
      },
    });
  };

  //view leave request
  useEffect(() => {
    const fetchData = async () => {
      const UserId = getUserId();
      const DepId = getDepId();
      const OrgID = getOrgId();

      // $&

      try {
        const requestData = {
          user_id: UserId,
          dept_id: DepId,
        };

        // $&
        // console.log('UserId:', UserId)

        const response = await axios.post(leaverequestview, requestData, {
          headers: HEADERS,
        });

        // $&

        if (response.data.response_code === "0000") {
          setdataview(response.data.data);

          // $&
        } else {
          console.error("Error fetching uers detail. Please try again later.");
        }

        // Fetch users
        const reqData = { org_id: OrgID };
        const resp = await axios.post(GetAllHead, reqData, {
          headers: HEADERS,
        });
        // $&

        if (resp.data.response_code === "0000") {
          setusergetall(resp.data.data);
          // $&
        } else {
          console.error("Error fetching users. Please try again later.");
        }

        // Fetch department
        const res = await axios.post(GetDepartment, reqData, {
          headers: HEADERS,
        });
        // console.log("response:", res.data)

        if (res.data.response_code === "0000") {
          // $&
          setDepartment(res.data.data);
        } else {
          console.error("Error fetching departments. Please try again later.");
        }
      } catch (error) {
        console.error(
          "An error occurred while fetching data.",
          error.response.data
        );
      }
    };

    fetchData();
  }, []);

  const tableData = dataview.map((data) => ({
    leave_request_id: data.leave_request_id,
    requested_by_name: data.requested_by_name,
    begin_date: data.begin_date,
    requested_for_name: data.requested_for_name || "", // Handle potential missing field
    leave_type_name: data.leave_type_name,
    end_date: data.end_date,
    department_name: data.department_name,
    leave_description: data.leave_description || "", // Handle potential missing field
    department: data.department,
    days_off: data.days_off,
    hours_off: data.hours_off,
    action: (
      <Link // Assuming Link is from a routing library like React Router
        className="d-flex justify-content-center text-decoration-none position-sticky right-0"
        to={{
          pathname: "/RequestForm", // Consistent path definition
          search: `leave_request_id=${data.leave_request_id}&requested_by_name=${data.requested_by_name}&department_name=${data.department_name}&begin_date=${data.begin_date}&end_date=${data.end_date}&leave_type_name=${data.leave_type_name}&leave_description=${data.leave_description}&department=${data.department}&days_off=${data.days_off}&hours_off=${data.hours_off}`,
        }}
      >
        <button
          className="view-button"
          style={{ color: "#2d7d9f", background: "transparent" }}
        >
          <strong>View</strong>
        </button>
      </Link>
    ),
  }));

  const tableColumns = [
    //... other columns
    {
      accessorKey: "leave_request_id",
      header: "Leave Request ID",
    },
    {
      accessorKey: "requested_by_name",
      header: "Requested By",
    },
    {
      accessorKey: "begin_date",
      header: "Begin Date",
    },
    {
      accessorKey: "end_date",
      header: "End Date",
    },
    {
      accessorKey: "leave_type_name",
      header: "Leave Type",
    },
    {
      accessorKey: "department_name",
      header: "Department",
    },
    {
      accessorKey: "action",
      header: "Action",
    },
  ];

  const paginatedData = tableData.slice(page * pageSize, (page + 1) * pageSize);

  const startRow = page * pageSize + 1;
  const endRow = Math.min((page + 1) * pageSize, tableData.length);
  const totalRows = tableData.length;

  const handlePageChange = (newPage) => {
    setPage(newPage); // Update the current page
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize); // Update the page size
  };

  return (
    <div className="row-container p-2">
      <Grid>
        <Grid.Col xs={12}>
          <div className="headerSection">
            <span className="title">Request Form</span>
            <div className="buttons">
              <Link to="">
                <button className=" border add-button" onClick={addLeavePolicy}>
                  Appoint Officiating
                </button>
              </Link>
            </div>
          </div>
        </Grid.Col>
        <Grid.Col xs={12}>
          <div className="tab mt-2">
            <MantineReactTable
              enableFullScreenToggle={false}
              columns={tableColumns}
              data={paginatedData}
              mantineTableBodyCellProps={{
                style: {
                  backgroundColor: "#C8E3EC60",
                  color: "#505050",
                  border: "0.5px solid #fff",
                  padding: "10px",
                },
              }}
              mantineTableHeadCellProps={{
                style: {
                  backgroundColor: "#2d7d9f",
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#fff",
                  border: "1px solid #fff",
                },
              }}
              mantineTableBodyRowProps={(row) => ({
                style: {
                  backgroundColor: row.index % 2 === 0 ? "#f9f9f9" : "#fff",
                },
              })}
              enablePagination={false}
              // enableColumnResizing
              enableColumnOrdering
              responsiveLayout={{ breakpoint: "sm" }}
            />
            <div className="pagination-container border p-2 d-flex flex-wrap justify-content-between align-items-center gap-3">
              <div className="d-flex align-items-center gap-2">
                <span style={{ fontSize: "14px" }}>Items per page:</span>
                <select
                  className="form-select"
                  style={{ width: "110px" }}
                  value={pageSize}
                  onChange={(e) =>
                    handlePageSizeChange(parseInt(e.target.value))
                  }
                >
                  <option value={5}>5 rows</option>
                  <option value={10}>10 rows</option>
                  <option value={20}>20 rows</option>
                  <option value={50}>50 rows</option>
                  <option value={100}>100 rows</option>
                </select>
              </div>
              <div className="d-flex justify-content-center align-items-center">
                <span style={{ fontSize: "14px" }}>
                  {totalRows === 0
                    ? "Showing 0 to 0 of 0 entries"
                    : `Showing ${startRow} - ${endRow} of ${totalRows} entries`}
                </span>
              </div>

              <div className="d-flex justify-content-center align-items-center gap-3">
                <button
                  className="previous-button"
                  onClick={() => handlePageChange(page - 1)}
                  disabled={page === 0}
                >
                  Previous
                </button>
                <button
                  className="add-button text-center justify-content-center"
                  style={{ width: "100px" }}
                  onClick={() => handlePageChange(page + 1)}
                  disabled={(page + 1) * pageSize >= tableData.length}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </Grid.Col>
      </Grid>
    </div>
  );
}

export default Approval;
